import { ShoppingCartOutlined, SwapOutlined, ToolOutlined } from '@ant-design/icons';
import { Tag } from 'antd';
import type { ProdutoLocalEstoque } from '../types/ProdutoLocalEstoque';

export function ProdutoLocalEstoqueUso({ local }: { local?: ProdutoLocalEstoque }) {
    if (!local) {
        return '-';
    }

    return (
        <div className='flex flex-wrap gap-1'>
            {local.est_permite_venda === 'S' && (
                <Tag color='green' icon={<ShoppingCartOutlined />}>
                    Venda
                </Tag>
            )}

            {local.est_permite_transferencia === 'S' && (
                <Tag color='blue' icon={<SwapOutlined />}>
                    Transferência
                </Tag>
            )}

            {local.est_permite_movimentacao_manual === 'S' && (
                <Tag color='orange' icon={<ToolOutlined />}>
                    Movimentação manual
                </Tag>
            )}
        </div>
    );
}
